import { OrderEnum, StageConfigSchema, StatusApplicableOnEnum } from '@/types/schema';

import { useProjectStagesQuery } from '../graphql/queries/generated/projectStages';

export const APPLICABLE_ON_FILTER = [StatusApplicableOnEnum.Task];

export const SORT_BY = { field: 'order', order: OrderEnum.Asc };

interface UseProjectStagesProps {
  projectId?: string;
}

function useProjectStages(props: UseProjectStagesProps) {
  const { projectId } = props;
  const [{ data, error, fetching }] = useProjectStagesQuery({
    variables: {
      filters: {
        id: projectId!,
      },
    },
    requestPolicy: 'cache-first',
    pause: !projectId,
  });

  const stages = data?.file?.stages?.filter((stage) => !!stage) as Array<
    Pick<StageConfigSchema, 'stageId' | 'name' | 'iconSettings'>
  >;

  return { stages, error, fetching };
}

export default useProjectStages;
